import {Injectable, inject} from "@angular/core";
import {MatPaginatorIntl} from "@angular/material/paginator";
import {Subject} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class LocalizedMatPaginator implements MatPaginatorIntl {
  private ts = inject(TranslateService);

  firstPageLabel = '';
  itemsPerPageLabel = '';
  lastPageLabel = '';
  nextPageLabel = '';
  previousPageLabel = '';
  changes = new Subject<void>();

  constructor() {

    this.ts.onLangChange.subscribe(lang => {
      this.firstPageLabel = this.ts.instant('shared.table.paginator.firstPage');
      this.itemsPerPageLabel = this.ts.instant('shared.table.paginator.itemsPerPage');
      this.lastPageLabel = this.ts.instant('shared.table.paginator.lastPage');
      this.nextPageLabel = this.ts.instant('shared.table.paginator.nextPage');
      this.previousPageLabel = this.ts.instant('shared.table.paginator.previousPage');
      this.changes.next();
    })

  }

  getRangeLabel(page: number, pageSize: number, length: number): string {
    let totPages = 1;
    if (length === 0) {
      page = 1;
    } else {
      totPages = Math.ceil(length / pageSize);
      page = page + 1;
    }

    return this.ts.instant('shared.table.paginator.pageXOfY', {
      start: ((page - 1) * pageSize) + 1,
      end: Math.min(length, (page - 1) * pageSize + pageSize),
      total: length,
      page,
      totPages
    });
  }
}
